import React, { useState } from 'react'
import { useEffect } from 'react';
import { deleteCourseParticipant, loadCourseParticipants, loadCourseParticipantsCount, loadUserTalent } from '../utils/Network';

export default function ParticipantsCount({ course_id}) {

    const [courseParticipantsCount, setcourseParticipantsCount] = useState(null);

    
    useEffect(() => {
        loadCourseParticipantsCount(course_id).then((courseParticipantsCount) => {
            setcourseParticipantsCount(courseParticipantsCount)
        })
        
    }, [])

    
    
    return (
        <>
            {courseParticipantsCount && courseParticipantsCount}
        </>
    )
}
